module.exports = __webpack_public_path__ + "img/unpublished-warning.87d3b769.svg";